import { inject, computed, ref, getCurrentInstance } from '@vue/composition-api';

import useAuthorizations from '@/compositions/user/useAuthorizations';

const useControlsItem = (props) => {
  const { emit } = getCurrentInstance();
  const { isAuthorized } = useAuthorizations();
  const wishList = inject('wishList');
  const { toggleFavorite } = inject('digitalDataManager');

  const isLoading = ref(false);

  const isWishItem = computed(() => {
    const item = wishList.state.productsId.find(findItem => +findItem === +props.productId);
    return !!item;
  });

  const wishText = computed(() => (isWishItem.value ? 'Отложено' : 'Отложить'));

  const type = computed(() => (isWishItem.value ? 'delete' : 'add'));

  const toggleToFavorites = async () => {
    if (!isAuthorized.value) {
      emit('openAuthModal');
    } else {
      isLoading.value = true;

      toggleFavorite({
        id: props.productId,
        price: props.amount.discounted,
        oldPrice: props.amount.total,
        categoryId: props.categoryId,
      }, type.value);

      switch (type.value) {
        case 'add': {
          await wishList.addToWishList(+props.productId);
          emit('moveToWishList');
          break;
        }

        case 'delete': {
          await wishList.removeInWishListItem(+props.productId);
          break;
        }
      }

      isLoading.value = false;
    }
  };

  const handlerRemoveItem = () => {
    emit('removeItem');
  };

  return {
    isAuthorized,
    isLoading,
    isWishItem,
    wishText,
    handlerRemoveItem,
    toggleToFavorites,
  };
};

export default useControlsItem;
